/* Custom Mobile Drawer (dentalkits.co) — Woodstock theme
 * - Relocates the section's content into the theme's #menu-drawer so the
 *   theme's focus trap / ESC / overlay / scroll-lock are reused untouched.
 * - Live countdown (fixed date or evergreen), banner close persistence,
 *   coupon apply/copy, accordion dropdowns. No external libraries.
 */
(function () {
  if (customElements.get('cmd-drawer')) return;

  var pad = function (n) { return n < 10 ? '0' + n : '' + n; };

  class CmdDrawer extends HTMLElement {
    connectedCallback() {
      // Already initialized (e.g. reconnect after relocation) -> just (re)start.
      if (this._ready) { this._startCountdown(); return; }

      var container = document.querySelector('#menu-drawer .menu-drawer__navigation-container');
      var alreadyInDrawer = !!this.closest('#menu-drawer');

      if (container && !alreadyInDrawer) {
        // Remove any stale copy from a previous theme-editor render of this section.
        var sid = this.getAttribute('data-section');
        container.querySelectorAll('cmd-drawer[data-section="' + sid + '"]').forEach(function (el) {
          if (el.parentElement) el.parentElement.removeChild(el);
        });
        // Hide the theme's original nav list while our drawer is active.
        var nav = container.querySelector('.menu-drawer__navigation');
        if (nav) nav.classList.add('cmd-theme-nav-hidden');
        // Move ourselves to the top of the drawer. Triggers disconnect+reconnect.
        container.insertBefore(this, container.firstChild);
        return; // reconnection runs the init path below
      }

      this._ready = true;
      this.removeAttribute('hidden');
      this._initBanner();
      this._initCoupon();
      this._initAccordions();
      this._startCountdown();
    }

    disconnectedCallback() {
      this._stopCountdown();
    }

    /* ---------------- Banner close + persistence ---------------- */
    _initBanner() {
      var banner = this.querySelector('[data-cmd-banner]');
      if (!banner) return;
      var key = 'cmd_banner_closed_' + this.getAttribute('data-section');
      var persist = banner.getAttribute('data-persist'); // session | day | never
      var until = null;
      try { until = window.localStorage.getItem(key); } catch (e) {}
      if (until) {
        if (until === 'session' && this._sessionFlag(key)) { banner.hidden = true; }
        else if (until !== 'session' && Date.now() < parseInt(until, 10)) { banner.hidden = true; }
      }
      var btn = banner.querySelector('[data-cmd-close]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        banner.hidden = true;
        try {
          if (persist === 'session') { sessionStorage.setItem(key, '1'); }
          else if (persist === 'day') { localStorage.setItem(key, String(Date.now() + 86400000)); }
        } catch (e) {}
      });
    }
    _sessionFlag(key) { try { return sessionStorage.getItem(key) === '1'; } catch (e) { return false; } }

    /* ---------------- Countdown ---------------- */
    _targetTime() {
      var b = this.querySelector('[data-cmd-banner]');
      if (!b) return null;
      if (b.getAttribute('data-evergreen') === 'true') {
        var mins = parseInt(b.getAttribute('data-evergreen-mins'), 10) || 30;
        var k = 'cmd_evergreen_' + this.getAttribute('data-section') + '_' + mins;
        var start;
        try { start = parseInt(localStorage.getItem(k), 10); } catch (e) {}
        if (!start) {
          start = Date.now();
          try { localStorage.setItem(k, String(start)); } catch (e) {}
        }
        return start + mins * 60000;
      }
      var raw = b.getAttribute('data-end'); // "YYYY-MM-DD HH:MM" (visitor local)
      if (!raw) return null;
      var iso = raw.trim().replace(' ', 'T');
      if (iso.length === 10) iso += 'T23:59';
      var t = new Date(iso).getTime();
      return isNaN(t) ? null : t;
    }

    _startCountdown() {
      this._stopCountdown();
      var banner = this.querySelector('[data-cmd-banner]');
      if (!banner || banner.hidden) return;
      var target = this._targetTime();
      if (target == null) return;
      var self = this;
      var els = {
        d: banner.querySelector('[data-cmd-days]'),
        h: banner.querySelector('[data-cmd-hours]'),
        m: banner.querySelector('[data-cmd-minutes]'),
        s: banner.querySelector('[data-cmd-seconds]')
      };
      var tick = function () {
        var diff = target - Date.now();
        if (diff <= 0) { self._onExpire(banner); return; }
        var totalSec = Math.floor(diff / 1000);
        var d = Math.floor(totalSec / 86400);
        var h = Math.floor((totalSec % 86400) / 3600);
        var m = Math.floor((totalSec % 3600) / 60);
        var s = totalSec % 60;
        if (els.d) els.d.textContent = pad(d);
        if (els.h) els.h.textContent = pad(h);
        if (els.m) els.m.textContent = pad(m);
        if (els.s) els.s.textContent = pad(s);
      };
      tick();
      this._interval = window.setInterval(tick, 1000);
    }
    _stopCountdown() { if (this._interval) { clearInterval(this._interval); this._interval = null; } }

    _onExpire(banner) {
      this._stopCountdown();
      var mode = banner.getAttribute('data-on-expire'); // hide | message | restart
      if (mode === 'hide') {
        banner.hidden = true;
      } else if (mode === 'restart') {
        // Evergreen restart: clear stored start and relaunch.
        var mins = parseInt(banner.getAttribute('data-evergreen-mins'), 10) || 30;
        var k = 'cmd_evergreen_' + this.getAttribute('data-section') + '_' + mins;
        try { localStorage.removeItem(k); } catch (e) {}
        this._startCountdown();
      } else { // message
        var grid = banner.querySelector('[data-cmd-timer]');
        var msg = banner.querySelector('[data-cmd-expired]');
        if (grid) grid.hidden = true;
        if (msg) msg.hidden = false;
      }
    }

    /* ---------------- Coupon ---------------- */
    _initCoupon() {
      var btn = this.querySelector('[data-cmd-cta]');
      if (!btn) return;
      var self = this;
      btn.addEventListener('click', function (e) {
        var action = btn.getAttribute('data-action'); // apply | copy | both | url
        var code = btn.getAttribute('data-code') || '';
        var url = btn.getAttribute('data-url') || '';
        var success = btn.getAttribute('data-success') || 'Done!';

        if (action === 'url') { return; } // plain link, let it navigate
        e.preventDefault();

        if (action === 'copy' || action === 'both') {
          self._copy(code);
        }
        self._flash(btn, success);

        if (action === 'apply' || action === 'both') {
          if (code) {
            window.setTimeout(function () {
              window.location.href = '/discount/' + encodeURIComponent(code);
            }, action === 'both' ? 450 : 0);
          }
        }
      });
    }
    _copy(text) {
      if (!text) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).catch(function () {});
      } else {
        try {
          var ta = document.createElement('textarea');
          ta.value = text; ta.setAttribute('readonly', '');
          ta.style.position = 'absolute'; ta.style.left = '-9999px';
          document.body.appendChild(ta); ta.select();
          document.execCommand('copy'); document.body.removeChild(ta);
        } catch (e) {}
      }
    }
    _flash(btn, msg) {
      var label = btn.querySelector('[data-cmd-cta-label]') || btn;
      if (btn._flashing) return;
      btn._flashing = true;
      var original = label.textContent;
      label.textContent = msg;
      btn.classList.add('is-success');
      window.setTimeout(function () {
        label.textContent = original;
        btn.classList.remove('is-success');
        btn._flashing = false;
      }, 2000);
    }

    /* ---------------- Accordion dropdowns ---------------- */
    _initAccordions() {
      var single = this.getAttribute('data-single-open') === 'true';
      var self = this;
      var toggles = this.querySelectorAll('[data-cmd-acc-toggle]');
      toggles.forEach(function (toggle) {
        // Initialise panels that start expanded (CSS default max-height is 0).
        if (toggle.getAttribute('aria-expanded') === 'true') {
          var p = document.getElementById(toggle.getAttribute('aria-controls'));
          if (p) { p.hidden = false; p.style.maxHeight = 'none'; }
        }
        toggle.addEventListener('click', function () {
          var panel = document.getElementById(toggle.getAttribute('aria-controls'));
          var open = toggle.getAttribute('aria-expanded') === 'true';
          if (single && !open) {
            self.querySelectorAll('[data-cmd-acc-toggle][aria-expanded="true"]').forEach(function (t) {
              if (t !== toggle) self._setAcc(t, document.getElementById(t.getAttribute('aria-controls')), false);
            });
          }
          self._setAcc(toggle, panel, !open);
        });
      });
    }
    _setAcc(toggle, panel, open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!panel) return;
      if (open) {
        panel.hidden = false;
        panel.style.maxHeight = panel.scrollHeight + 'px';
        var clear = function () { panel.style.maxHeight = 'none'; panel.removeEventListener('transitionend', clear); };
        panel.addEventListener('transitionend', clear);
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        // force reflow then collapse
        void panel.offsetHeight;
        panel.style.maxHeight = '0px';
        var hide = function () { panel.hidden = true; panel.removeEventListener('transitionend', hide); };
        panel.addEventListener('transitionend', hide);
      }
    }
  }

  customElements.define('cmd-drawer', CmdDrawer);

  /* Theme-controlled mobile account icon: insert before Shopify's shadow-DOM
     shopify-account host and hide the original (via class) on mobile. */
  class CmdAccount extends HTMLElement {
    connectedCallback() {
      if (this._done) return;
      var sid = this.getAttribute('data-section');
      var target = document.querySelector(this.getAttribute('data-target'));
      // Remove a stale copy left in the header after a theme-editor re-render.
      var self = this;
      document.querySelectorAll('cmd-account[data-relocated="' + sid + '"]').forEach(function (el) {
        if (el !== self) el.remove();
      });
      if (target && target.parentElement) {
        this._done = true;
        this.hidden = false;
        target.classList.add('cmd-acct-hide-original');
        this.setAttribute('data-relocated', sid);
        target.parentElement.insertBefore(this, target); // re-triggers connectedCallback (guarded by _done)
      }
    }
  }
  if (!customElements.get('cmd-account')) customElements.define('cmd-account', CmdAccount);

  // Re-run relocation when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('cmd-drawer');
    if (el && !el._ready && !el.closest('#menu-drawer')) {
      // connectedCallback handles relocation; nudge if needed.
      if (el.isConnected) el.connectedCallback();
    }
  });
})();
